import DepositPage from './DepositPage';

export default DepositPage;
